import React from 'react';
import { H1 } from '../H1/H1.jsx';
import { RevalidateDot } from '../RevalidateDot/RevalidateDot.jsx';
import { ViewOnlyPill } from '../ViewOnlyPill/ViewOnlyPill.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Title, sub-line and actions for the top of a page; `viewOnly` adds the pill, `stale` the
 * RevalidateDot.
 *
 * @param {object} p
 * @param {boolean|'session'} [p.drop]
 * @param {React.ReactNode} p.title
 * @param {React.ReactNode} [p.sub]
 * @param {React.ReactNode} [p.actions]
 * @param {boolean} [p.viewOnly]
 * @param {boolean} [p.stale]
 * @param {number} [p.titleSize]
 * @param {number} [p.gap]
 */
export function PageHeader({ title, sub, actions, viewOnly, stale, titleSize = 34, gap = 20, drop }) {
  return h('div', { style: { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap, flexWrap: 'wrap' } },
    h('div', { style: { display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 } },
      h('div', { style: { display: 'flex', alignItems: 'center', gap: 10 } }, h(H1, { size: titleSize, drop }, title), stale ? h(RevalidateDot, { size: 14 }) : null),
      sub ? h('div', { style: { fontFamily: BODY, fontSize: 14.5, color: 'var(--tx2)', textWrap: 'pretty' } }, sub) : null),
    (actions || viewOnly) ? h('div', { style: { display: 'flex', alignItems: 'center', gap: 9, flexWrap: 'wrap' } }, viewOnly ? h(ViewOnlyPill) : null, actions) : null);
}
